/**
 * @generated SignedSource<<513dadf6c88bf71cff3dcc01e31ee602>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareRequests_noteAccessRequests$data = {
  readonly pendingAccessRequests: ReadonlyArray<{
    readonly createdAt: string;
    readonly id: string;
    readonly requestor: {
      readonly email: string;
      readonly fullName: string;
      readonly id: string;
      readonly image: string;
      readonly isExternal: boolean;
    };
  }>;
  readonly " $fragmentType": "ShareRequests_noteAccessRequests";
};
export type ShareRequests_noteAccessRequests$key = {
  readonly " $data"?: ShareRequests_noteAccessRequests$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShareRequests_noteAccessRequests">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShareRequests_noteAccessRequests",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteAccessRequestNode",
      "kind": "LinkedField",
      "name": "pendingAccessRequests",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "requestor",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isExternal",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "89d31d5152ff81e7c68e57ef8f0f0152";

export default node;
